import { useCallback, useState } from 'react';

// Answers for every question (locked + custom) live in one keyed object, indexed by
// questionKey, instead of one useState per field like the legacy addCounselor.js did.
export const useStaffFormAnswers = (initial = {}) => {
    const [values, setValues] = useState(initial);
    const [errors, setErrors] = useState({});

    const setValue = useCallback((questionKey, value) => {
        setValues(prev => ({ ...prev, [questionKey]: value }));
        setErrors(prev => (prev[questionKey] ? { ...prev, [questionKey]: undefined } : prev));
    }, []);

    const setMany = useCallback(patch => {
        setValues(prev => ({ ...prev, ...patch }));
    }, []);

    return { values, setValues, setValue, setMany, errors, setErrors };
};
